import Breadcrumbs from "../breadcrumbs/breadcrumb";
import BackButton from "../buttons/BackButton";

export const Header = ({ title, breadcrumbItems }) => (
    <div className="flex items-start gap-2">
        <BackButton className="mr-2" />
        <div className="heading">
            <h1 className="text-2xl sm:text-3xl font-bold text-slate-800 flex items-center">{title}</h1>
            <Breadcrumbs items={breadcrumbItems} />
        </div>
    </div>
);
